<form class="quoteForm" #quoteForm="ngForm">
  @if (quote(); as quote) {
    <div class="toolbar">
      <span>
        <button matButton="text" class="toolbarButton" [disabled]="isBusy()" (click)="backToQuoteMaster()">
          <span>
            <mat-icon class="size-16">keyboard_arrow_left</mat-icon>
            <span class="buttonLabel">Back To Search</span>
          </span>
        </button>
      </span>
      <span class="spacer"></span>
      <span class="buttonContainer">
        @if (!isNew() && quote.updateAllowed && quote.projectProductType === ProjectProductType.COM) {
          <button matButton="text" class="toolbarButton" [matMenuTriggerFor]="projectActionsMenu">
            <span>
              <span class="buttonLabel">Project Defaults</span>
              <mat-icon class="size-16">arrow_drop_down</mat-icon>
            </span>
          </button>
        }
        <mat-menu #projectActionsMenu="matMenu" [overlapTrigger]="false">
          <button class="menuButton" mat-menu-item (click)="openProjectDefaultsScreen()">
            <mat-icon class="size-12">dashboard</mat-icon>
            <span class="buttonLabel">Project Level Information</span>
          </button>
        </mat-menu>
        @if (!isNew() && quote.updateAllowed) {
          <button matButton="text" class="toolbarButton" [disabled]="isBusy()" [matMenuTriggerFor]="pricingMenu">
            <span>
              <span class="buttonLabel">Pricing</span>
              <mat-icon class="size-16">arrow_drop_down</mat-icon>
            </span>
          </button>
        }
        <mat-menu #pricingMenu="matMenu" [overlapTrigger]="false">
          <button class="menuButton" mat-menu-item [disabled]="quoteForm.invalid" (click)="multiplier()">
            <mat-icon class="size-12">keyboard</mat-icon>
            <span class="buttonLabel">Multiplier</span>
          </button>
          @if (showFpaManagementButton()) {
            <button class="menuButton" mat-menu-item (click)="fpaManagement()">
              <mat-icon class="size-12">attach_money</mat-icon>
              <span class="buttonLabel">Request FPA</span>
            </button>
          }
          @if (showFpaCancelButton()) {
            <button class="menuButton" mat-menu-item (click)="cancelFpaReview()">
              <mat-icon class="size-12">cancel</mat-icon>
              <span class="buttonLabel">Cancel FPA Review</span>
            </button>
          }
          @if (userHasRole("IT") || userHasRole("CustomerService")) {
            <button class="menuButton" mat-menu-item (click)="viewEntityBreaks()">
              <mat-icon class="size-12">subject</mat-icon>
              <span class="buttonLabel">Quote Breaks</span>
            </button>
          }
          @if (canUpdateExtendedWarranty()) {
            <button class="menuButton" mat-menu-item (click)="showExtendedWarrantyDialog()">
              <mat-icon class="size-12">verified</mat-icon>
              <span class="buttonLabel">Extended Warranty</span>
            </button>
          }
          @if (isInternalOrRsm()) {
            <button class="menuButton" mat-menu-item (click)="openCostReport()">
              <mat-icon class="size-12">request_quote</mat-icon>
              <span class="buttonLabel">Cost Report</span>
            </button>
          }
        </mat-menu>
        @if (!isNew()) {
          <button matButton="text" class="toolbarButton" [disabled]="isBusy()" [matMenuTriggerFor]="actionsMenu">
            <span>
              <span class="buttonLabel">Actions</span>
              <mat-icon class="size-16">arrow_drop_down</mat-icon>
            </span>
          </button>
        }
        <mat-menu #actionsMenu="matMenu" [overlapTrigger]="false">
          @if (!isStockProgram()) {
            <button class="menuButton" mat-menu-item (click)="copy()">
              <mat-icon class="size-12">add_to_photos</mat-icon>
              <span class="buttonLabel">Copy</span>
            </button>
          }
          @if (quote.updateAllowed) {
            <button class="menuButton" mat-menu-item (click)="cancel()">
              <mat-icon class="size-12">do_not_disturb</mat-icon>
              <span class="buttonLabel">Cancel</span>
            </button>
          }
          @if (canApprove()) {
            <button class="menuButton" mat-menu-item (click)="approveQuote()">
              <mat-icon class="size-12">assignment_turned_in</mat-icon>
              <span class="buttonLabel">Approve</span>
            </button>
          }
          @if (userHasRole("IT") || userHasRole("CustomerService")) {
            <button class="menuButton" mat-menu-item (click)="fixPermissions()">
              <mat-icon class="size-12">lock_open</mat-icon>
              <span class="buttonLabel">Fix Permissions</span>
            </button>
          }
          @if (userHasRole("IT")) {
            <button class="menuButton" mat-menu-item (click)="openQewlDialog()">
              <mat-icon class="size-12">layers</mat-icon>
              <span class="buttonLabel">QEWL</span>
            </button>
          }
          @if (showAssignNewOpportunityOption() && isInternalOrRsm()) {
            <button class="menuButton" mat-menu-item (click)="assignNewOpportunity()">
              <mat-icon class="size-12">autorenew</mat-icon>
              <span class="buttonLabel">Assign New Opportunity</span>
            </button>
          }
          @if (showUnrestrictedEditOption()) {
            <button class="menuButton" mat-menu-item (click)="showUnrestrictedChangesDialog()">
              <mat-icon class="size-12">edit</mat-icon>
              <span class="buttonLabel">Update Approved Quote</span>
            </button>
          }
        </mat-menu>
        @if (showSpecialQuotes()) {
          <button matButton="text" class="toolbarButton" [disabled]="isBusy()" (click)="specialQuotes()">
            <span>
              <span class="buttonLabel">Special Quotes</span>
            </span>
          </button>
        }
        @if (!isNew()) {
          <button matButton="text" class="toolbarButton" [disabled]="isBusy()" (click)="viewDocuments()">
            <span>
              <mat-icon class="size-16">content_copy</mat-icon>
              <span class="buttonLabel">Docs</span>
            </span>
          </button>
        }
        @if (!isNew()) {
          <button matButton="text" class="toolbarButton" [disabled]="isBusy()" [matMenuTriggerFor]="viewMenu">
            <span>
              <span class="buttonLabel">View</span>
              <mat-icon class="size-16">arrow_drop_down</mat-icon>
            </span>
          </button>
        }
        <mat-menu #viewMenu="matMenu" [overlapTrigger]="false">
          @if (quote.opportunityId && quote.opportunityId.length > 0 && userCanViewOpportunity()) {
            <a class="menuButton" mat-menu-item [routerLink]="['/opportunities', quote.opportunityId, quote.opportunityRevision]" target="_blank">
              <mat-icon class="size-12">attach_file</mat-icon>
              <span class="buttonLabel">Opportunity</span>
            </a>
          }
          @if (associatedOrders() && associatedOrders().length > 0) {
            <button class="menuButton" mat-menu-item [matMenuTriggerFor]="associatedOrdersMenu">
              <mat-icon class="size-12">attach_file</mat-icon>
              <span class="buttonLabel">Order</span>
            </button>
          }
          <button class="menuButton" mat-menu-item (click)="showEntityHistoryDialog()">
            <mat-icon class="size-12">history</mat-icon>
            <span class="buttonLabel">History</span>
          </button>
        </mat-menu>
        <mat-menu #associatedOrdersMenu="matMenu">
          @for (order of associatedOrders(); track order) {
            <button class="menuButton" mat-menu-item (click)="viewOrder(order)">
              <span class="buttonLabel">{{ order.entityId }};{{ order.entityRevision }}</span>
            </button>
          }
        </mat-menu>
        @if (quote.updateAllowed) {
          <button matButton="text" class="toolbarButton" [disabled]="isBusy() || !quoteForm.valid" (click)="save()">
            <span>
              <mat-icon class="size-16">save</mat-icon>
              <span class="buttonLabel">Save</span>
            </span>
          </button>
        }
        @if (showPlaceOrderButton()) {
          <button matButton="text" class="toolbarButton" [disabled]="isBusy()" (click)="placeOrder()">
            <span>
              <mat-icon class="size-16">done</mat-icon>
              <span class="buttonLabel">Place Order</span>
            </span>
          </button>
        }
        @if (showCancelPlaceOrderButton()) {
          <button matButton="text" class="toolbarButton" [disabled]="isBusy()" (click)="cancelPlaceOrder()">
            <span>
              <mat-icon class="size-16">clear</mat-icon>
              <span class="buttonLabel">Cancel Place Order</span>
            </span>
          </button>
        }
      </span>
    </div>
  }
  @if (errorMessages() && errorMessages().length > 0) {
    <div class="errorMessage">
      <pre>{{ createErrorMessage() }}</pre>
    </div>
  }
  @if (saveMessages() && saveMessages().length > 0) {
    <div class="saveMessage">
      @for (message of saveMessages(); track message) {
        <div>
          {{ message }}
        </div>
      }
    </div>
  }
  @if (isBusy()) {
    <div class="busyIndicator">
      <div class="busyContents">
        <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
        <span class="busyLabel">{{ waitMessage() }}</span>
      </div>
    </div>
  }
  @if (quote(); as quote) {
    <div class="quoteDetail">
      <div class="thirdColumn">
        <div class="infoPanel">
          <div class="panelHeader">
            <span>Quote Information</span>
          </div>
          <div class="panelBody">
            <table class="layoutTable">
              @if (quote.id && quote.id.entityId && quote.id.entityId.length > 0) {
                <tr>
                  <td class="rightAligned labelColumn"><span>QuoteID:</span></td>
                  <td class="dataColumn">
                    <span>{{ quote.id.entityId }};{{ quote.id.entityRevision }}</span>
                  </td>
                </tr>
              }
              <tr>
                <td class="rightAligned labelColumn"><label for="projectNameInput">Project Name:</label></td>
                <td class="dataColumn">
                  <input
                    id="projectNameInput"
                    name="projectNameInput"
                    class="inputField standardTextBox"
                    maxlength="30"
                    [ngClass]="{ inputError: projectNameInput.invalid }"
                    required
                    [(ngModel)]="quote.projectName"
                    #projectNameInput="ngModel" />
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Brand:</span></td>
                @if (quote.lines && quote.lines.length > 0) {
                  <td class="dataColumn">
                    <span>{{ this.selectedBrand() }}</span>
                  </td>
                }
                @if (!quote.lines || quote.lines.length === 0) {
                  <td class="dataColumn">
                    <div>
                      <select
                        name="brandSelection"
                        class="inputField"
                        required
                        [ngClass]="{ inputError: brandSelection.invalid }"
                        [(ngModel)]="this.selectedBrand"
                        #brandSelection="ngModel"
                        (ngModelChange)="brandChange()">
                        <option value="undefined" disabled>Please Select</option>
                        @for (ppt of orgunitPPTs(); track ppt) {
                          <option [ngValue]="ppt.code">
                            {{ ppt.description }}
                          </option>
                        }
                      </select>
                    </div>
                  </td>
                }
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><label for="customerSelection">Customer:</label></td>
                <td class="dataColumn">
                  <select id="customerSelection" name="customerSelection" class="inputField" [(ngModel)]="quote.customerId">
                    @for (customer of customers(); track customer) {
                      <option [ngValue]="customer.code">
                        {{ customer.description }}
                      </option>
                    }
                  </select>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Rep Office:</span></td>
                <td class="dataColumn">
                  @if (showRepOfficeDropDown()) {
                    <div [ngClass]="{ selectionError: repOfficeSelection.invalid }">
                      <select
                        id="repOfficeSelection"
                        name="repOfficeSelection"
                        class="inputField"
                        required
                        [(ngModel)]="quote.repOfficeId"
                        (change)="loadSellingOrganizationSelections()"
                        #repOfficeSelection="ngModel">
                        <option value="undefined" disabled>Please Select</option>
                        @for (rep of repOffices(); track rep) {
                          <option [ngValue]="rep.code">{{ rep.description }}</option>
                        }
                      </select>
                    </div>
                  }
                  @if (!showRepOfficeDropDown()) {
                    <span>{{ selectedSellingOrg()?.description }}</span>
                  }
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Release Type:</span></td>
                <td class="dataColumn">
                  <div [ngClass]="{ selectionError: releaseTypeSelection.invalid }">
                    <select name="releaseTypeSelection" class="inputField" required [(ngModel)]="quote.releaseTypeId" #releaseTypeSelection="ngModel">
                      <option value="undefined" disabled>Please Select</option>
                      @for (releaseType of releaseTypes(); track releaseType) {
                        <option [ngValue]="releaseType.code">
                          {{ releaseType.description }}
                        </option>
                      }
                    </select>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Associated Quote:</span></td>
                <td class="dataColumn">
                  <span>{{ quote.associatedQuoteId }}</span>
                </td>
              </tr>
              @if (canUpdateInternalNotes()) {
                <tr>
                  <td colspan="2">
                    <textarea name="internalNotesInput" rows="3" class="noresize fullWidth" [(ngModel)]="quote.internalNotes" placeholder="Internal Notes"></textarea>
                  </td>
                </tr>
              }
            </table>
          </div>
        </div>
        <div class="infoPanel">
          <div class="panelHeader">
            <span>Processing and Contacts</span>
          </div>
          <div class="panelBody">
            <table class="layoutTable">
              <tr>
                <td class="rightAligned labelColumn"><span>Est Sch Date:</span></td>
                <td class="dataColumn">
                  <span>{{ quote.estimatedScheduleDate | date: "MM/dd/yyyy" : "UTC" }}</span>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>FOB:</span></td>
                <td class="dataColumn">
                  @if (userHasRole("IT") || userHasRole("CredAnalyst")) {
                    <div [ngClass]="{ selectionError: fobCodeInput.invalid }">
                      <select name="fobCodeInput" class="inputField" required [(ngModel)]="quote.fobCode" #fobCodeInput="ngModel">
                        <option value="undefined" disabled>Please Select</option>
                        @for (fob of fobs(); track fob) {
                          <option [ngValue]="fob.code">{{ fob.description }}</option>
                        }
                      </select>
                    </div>
                  }
                  @if (!userHasRole("IT") && !userHasRole("CredAnalyst")) {
                    <span>{{ quote.fobCode }}</span>
                  }
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Order Info:</span></td>
                <td class="dataColumn">
                  @if (userHasRole("IT") || userHasRole("CustomerService")) {
                    <div>
                      <input name="orderInfoInput" class="inputField standardTextBox" maxlength="10" [(ngModel)]="quote.orderInfo" #orderInfoInput />
                    </div>
                  }
                  @if (!userHasRole("IT") && !userHasRole("CustomerService")) {
                    <div>
                      <span>{{ quote.orderInfo }}</span>
                    </div>
                  }
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Payment Terms:</span></td>
                <td class="dataColumn">
                  @if (userHasRole("IT") || userHasRole("CredAnalyst")) {
                    <div [ngClass]="{ selectionError: paymentTermsInput.invalid }">
                      <select name="paymentTermsInput" class="inputField" required [(ngModel)]="quote.paymentTermsCode" #paymentTermsInput="ngModel">
                        <option value="undefined" disabled>Please Select</option>
                        @for (paymentTerm of paymentTerms(); track paymentTerm) {
                          <option [ngValue]="paymentTerm.code">
                            {{ paymentTerm.description }}
                          </option>
                        }
                      </select>
                    </div>
                  }
                  @if (!userHasRole("IT") && !userHasRole("CredAnalyst")) {
                    <span>{{ quote.paymentTermsCode }}</span>
                  }
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn">
                  <span>Expiration Date:</span>
                </td>
                <td class="dataColumn">
                  @if (userHasRole("IT") || userHasRole("CustomerService")) {
                    <div>
                      <input
                        [matDatepicker]="expirationDatePicker"
                        name="expirationDateInput"
                        [value]="formatDisplayDate(quote.expirationDate)"
                        (dateChange)="setExpirationDate($event.value)" />
                      <mat-datepicker-toggle [for]="expirationDatePicker"></mat-datepicker-toggle>
                      <mat-datepicker id="expirationDatePicker" name="expirationDatePicker" #expirationDatePicker></mat-datepicker>
                    </div>
                  }
                  @if (!userHasRole("IT") && !userHasRole("CustomerService")) {
                    <span>{{ quote.expirationDate | date: "MM/dd/yyyy" : "UTC" }}</span>
                  }
                </td>
              </tr>
              <tr>
                <td class="rightAligned" (click)="showSalesRep()">
                  <span class="repSelection">Sales Rep:</span>
                </td>
                <td class="dataColumn">
                  <div [ngClass]="{ selectionError: salesRepIdInput.invalid }">
                    <select id="salesRepIdInput" name="salesRepIdInput" class="inputField" required [(ngModel)]="quote.salesRepId" #salesRepIdInput="ngModel">
                      <option value="undefined" disabled>Please Select</option>
                      @for (salesRep of salesReps(); track salesRep) {
                        <option [ngValue]="salesRep.code">
                          {{ salesRep.description }}
                        </option>
                      }
                    </select>
                  </div>
                </td>
              </tr>
              @if (quote.totalQuoteAmount > 50000) {
                <tr>
                  <td class="rightAligned labelColumn"><label for="outsideSalesRepIdInput">Outside Sales Rep:</label></td>
                  <td class="dataColumn">
                    <div [ngClass]="{ selectionError: outsideSalesRepIdInput.invalid }">
                      <select
                        id="outsideSalesRepIdInput"
                        name="outsideSalesRepIdInput"
                        class="inputField"
                        [required]="quote.totalQuoteAmount > 50000"
                        [(ngModel)]="quote.outsideSalesRepId"
                        #outsideSalesRepIdInput="ngModel">
                        <option value="undefined" disabled>Please Select</option>
                        @for (salesRep of outsideSalesReps(); track salesRep) {
                          <option [ngValue]="salesRep.code">
                            {{ salesRep.description }}
                          </option>
                        }
                      </select>
                    </div>
                  </td>
                </tr>
              }
              <tr>
                <td class="rightAligned labelColumn">
                  <span>SFR Price Date:</span>
                </td>
                <td class="dataColumn">
                  @if (userHasRole("IT")) {
                    <div>
                      <input
                        [matDatepicker]="sfrPriceDatePicker"
                        name="sfrPriceDateInput"
                        [value]="formatDisplayDate(quote.sfrPriceBasisDate)"
                        (dateChange)="setSfrPriceDate($event.value)" />
                      <mat-datepicker-toggle [for]="sfrPriceDatePicker"></mat-datepicker-toggle>
                      <mat-datepicker id="sfrPriceDatePicker" name="sfrPriceDatePicker" #sfrPriceDatePicker></mat-datepicker>
                    </div>
                  }
                  @if (!userHasRole("IT")) {
                    <span>{{ quote.sfrPriceBasisDate | date: "MM/dd/yyyy" : "UTC" }}</span>
                  }
                </td>
              </tr>
              <tr>
                <td class="rightAligned" (click)="showIecContact()">
                  <span class="repSelection">Contact:</span>
                </td>
                <td class="dataColumn">
                  @if (userHasRole("CustomerService") || userHasRole("IT") || userHasRole("CredAnalyst") || userHasRole("ApplicationEngineer") || userHasRole("RSM")) {
                    <div [ngClass]="{ selectionError: iecContactIdInput.invalid }">
                      <select name="iecContactIdInput" class="inputField" required [(ngModel)]="quote.iecContactId" #iecContactIdInput="ngModel">
                        <option value="null" disabled>Please Select</option>
                        @for (iecContact of iecContacts(); track iecContact) {
                          <option [ngValue]="iecContact.code">
                            {{ iecContact.description }}
                          </option>
                        }
                      </select>
                    </div>
                  }
                  @if (!userHasRole("CustomerService") && !userHasRole("IT") && !userHasRole("CredAnalyst") && !userHasRole("ApplicationEngineer") && !userHasRole("RSM")) {
                    <span>{{ quote.iecContactDescription }}</span>
                  }
                </td>
              </tr>
              @if (quote.skyportServicePresent) {
                <tr>
                  <td [ngClass]="{ skyportError: skyportContactMissing() }" class="rightAligned" (click)="selectSkyportContact()">
                    <span class="repSelection">Skyport Contact</span>
                  </td>
                </tr>
              }
              <tr>
                <td class="rightAligned labelColumn"><span>Last Process Date:</span></td>
                <td class="dataColumn">
                  <span>{{ quote.lastProcessDate | date: "MM/dd/yyyy" : "UTC" }}</span>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <span>Created: {{ createdBy() }} - {{ quote.createTimestamp | date: "MM/dd/yyyy h:mm:ss a" : "UTC" }}</span>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <span>Updated: {{ updatedBy() }} - {{ quote.updateTimestamp | date: "MM/dd/yyyy h:mm:ss a" : "UTC" }}</span>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="thirdColumn">
        <div class="infoPanel">
          <div class="panelHeader">
            <span>Pricing Controls</span>
          </div>
          <div class="panelBody">
            <table class="layoutTable">
              <tr>
                @if (showWarrantyTextLink()) {
                  <td (click)="showWarrantyText()">
                    <span class="warrantyTextSelection">Warranty Text</span>
                  </td>
                } @else {
                  <td></td>
                }
                <td class="rightAligned labelColumn"><span>Lead Time:</span></td>
                <td class="dataColumn">
                  @if (isStockProgram()) {
                    <span>{{ leadTimeDescription() }}</span>
                  }
                  @if (!isValidWarrantyLeadTime() && quote.leadTimeCode !== "SLC" && !isStockProgram()) {
                    <div>
                      <select name="leadTimeCodeInput" class="inputField" #leadTimeCodeInput="ngModel" [(ngModel)]="quote.leadTimeCode">
                        @for (leadTime of leadTimes(); track leadTime) {
                          <option [ngValue]="leadTime.code">
                            {{ leadTime.description }}
                          </option>
                        }
                      </select>
                    </div>
                  }
                  @if (isValidWarrantyLeadTime()) {
                    <span>Warranty</span>
                  }
                  @if (quote.leadTimeCode === "SLC") {
                    <span>Sales Concession</span>
                  }
                </td>
              </tr>
              <tr>
                <td></td>
                <td class="rightAligned labelColumn"><span>Sales Channel:</span></td>
                <td class="dataColumn">
                  <select name="salesChannelCodeInput" class="inputField" [(ngModel)]="quote.salesChannelCode">
                    @for (salesChannel of salesChannels(); track salesChannel) {
                      <option [ngValue]="salesChannel.code">
                        {{ salesChannel.description }}
                      </option>
                    }
                  </select>
                </td>
              </tr>
              @if (userHasRole("IT") || userHasRole("CustomerService") || userHasRole("CredAnalyst")) {
                <tr>
                  <td></td>
                  <td class="rightAligned labelColumn"><span>Use Type:</span></td>
                  <td class="dataColumn">
                    <select name="useTypeCodeInput" class="inputField" [(ngModel)]="quote.useTypeCode" #useTypeCodeInput>
                      <option value="null" disabled>Please Select</option>
                      @for (useType of useTypes(); track useType) {
                        <option [ngValue]="useType.code">
                          {{ useType.description }}
                        </option>
                      }
                    </select>
                  </td>
                </tr>
              }
              <tr>
                <td></td>
                <td class="rightAligned labelColumn"><span>Price Basis Date:</span></td>
                <td class="dataColumn">
                  @if (userHasRole("IT")) {
                    <div>
                      <input
                        [matDatepicker]="priceBasisDatePicker"
                        name="priceBasisDateInput"
                        [value]="formatDisplayDate(quote.priceBasisDate)"
                        (dateChange)="setPriceBasisDate($event.value)" />
                      <mat-datepicker-toggle [for]="priceBasisDatePicker"></mat-datepicker-toggle>
                      <mat-datepicker id="priceBasisDatePicker" name="priceBasisDatePicker" #priceBasisDatePicker></mat-datepicker>
                    </div>
                  }
                  @if (!userHasRole("IT")) {
                    <span>{{ quote.priceBasisDate | date: "MM/dd/yyyy" : "UTC" }}</span>
                  }
                </td>
              </tr>
              <tr>
                <td></td>
                <td class="rightAligned labelColumn"><span>S&amp;H Charge Type:</span></td>
                <td class="dataColumn">
                  <div>
                    <select name="shipChargeTypeInput" class="inputField" disabled [(ngModel)]="quote.shipAndHandChargeType" #shipChargeTypeInput>
                      <option value="null" disabled>Please Select</option>
                      @for (sAndHChargeType of sAndHChargeTypes(); track sAndHChargeType) {
                        <option [ngValue]="sAndHChargeType.code">
                          {{ sAndHChargeType.description }}
                        </option>
                      }
                    </select>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="infoPanel">
          <div class="panelHeader">
            <span>Shipping Information</span>
          </div>
          <div class="panelBody">
            <table class="layoutTable">
              <tr>
                <td class="rightAligned labelColumn"><span>Ship To:</span></td>
                <td class="dataColumn" (click)="!isNew() && selectAddress()">
                  <span class="addressSelection" [ngClass]="{ 'disabled-cell': isNew() }">
                    {{ quote.overrideShipToAddressLine1 || "Select" }}
                  </span>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Ship Via:</span></td>
                <td class="dataColumn">
                  <select name="shipViaCodeInput" class="inputField" [(ngModel)]="quote.shipViaCode" (change)="shipViaChange(shipViaCodeInput.value)" #shipViaCodeInput>
                    <option value="null" disabled>Please Select</option>
                    @for (shipVia of shipVias(); track shipVia) {
                      <option [ngValue]="shipVia.code">
                        {{ shipVia.description }}
                      </option>
                    }
                  </select>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"></td>
                <td class="dataColumn">
                  <input name="partialAllowedInput" id="partialAllowedInput" class="checkboxInput" type="checkbox" [(ngModel)]="quote.partialShipmentAllowed" />
                  <label for="partialAllowedInput">Partial Shipment Allowed</label>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Requested Ship Date:</span></td>
                <td class="dataColumn">
                  <input
                    [matDatepicker]="requestedShipDatePicker"
                    name="requestedShipDateInput"
                    [value]="formatDisplayDate(quote.requestedShipDate)"
                    [min]="minRequestedShipDate"
                    (dateChange)="setRequestedShipDate($event.value)" />
                  <mat-datepicker-toggle [for]="requestedShipDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker id="requestedShipDatePicker" name="requestedShipDatePicker" #requestedShipDatePicker></mat-datepicker>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"></td>
                <td class="dataColumn">
                  <input name="acceptEarlyInput" id="acceptEarlyInput" class="checkboxInput" type="checkbox" [(ngModel)]="quote.acceptEarlyDelivery" />
                  <label for="acceptEarlyInput">Accept Early Delivery</label>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"></td>
                <td class="dataColumn">
                  <input name="includeShippingTagsInput" id="includeShippingTagsInput" class="checkboxInput" type="checkbox" [checked]="quote.includeShippingTags" disabled />
                  <label for="includeShippingTagsInput">Include Shipping Tags</label>
                  <mat-icon class="shippingTagInfoIcon" [matTooltip]="getIncludeShippingTagsTooltip()">info_outline</mat-icon>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Advance Notice Hours:</span></td>
                <td class="dataColumn">
                  <input name="advanceNoticeHoursInput" class="inputField standardTextBox" maxlength="28" [(ngModel)]="quote.advanceNoticeHours" #advanceNoticeHoursInput />
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Rep PO#:</span></td>
                <td class="dataColumn">
                  <input name="repPoInput" class="inputField standardTextBox" maxlength="15" [(ngModel)]="quote.repPo" #repPoInput />
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Rep Ref#:</span></td>
                <td class="dataColumn">
                  <input name="repRefInput" class="inputField standardTextBox" maxlength="15" [(ngModel)]="quote.repRef" #repRefInput />
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Primary Contact:</span></td>
                <td class="dataColumn" (click)="enterContact(true)">
                  <span [hidden]="quote.deliveryContactName || quote.deliveryPhone" class="addressSelection">Enter Contact</span>
                  <span [hidden]="!(quote.deliveryContactName || quote.deliveryPhone)" class="addressSelection">
                    {{ quote.deliveryContactName + "; " + quote.deliveryPhone }}
                  </span>
                </td>
              </tr>
              <tr [hidden]="!(quote.deliveryContactName && quote.deliveryPhone)">
                <td class="rightAligned labelColumn"><span>Secondary Contact:</span></td>
                <td class="dataColumn" (click)="enterContact(false)">
                  <span [hidden]="quote.deliveryContactName2 || quote.deliveryPhone2" class="addressSelection">Enter Contact</span>
                  <span [hidden]="!(quote.deliveryContactName2 || quote.deliveryPhone2)" class="addressSelection">
                    {{ quote.deliveryContactName2 + "; " + quote.deliveryPhone2 }}
                  </span>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Delivery Country:</span></td>
                <td class="dataColumn">
                  <select name="deliveryCountryInput" class="inputField" [(ngModel)]="quote.deliveryCountryCode" #deliveryCountryInput>
                    <option value="null" disabled>Please Select</option>
                    @for (country of deliveryCountries(); track country) {
                      <option [ngValue]="country.code">
                        {{ country.description }}
                      </option>
                    }
                  </select>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Mark Cartons:</span></td>
                <td class="dataColumn">
                  <input name="markCartonsInput" class="inputField standardTextBox" maxlength="30" [(ngModel)]="quote.markCartons" #markCartonsInput />
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <mat-form-field class="input-field fullWidth" appearance="outline" subscriptSizing="dynamic">
                    <textarea matInput name="externalNotesInput" rows="3" maxlength="255" class="noresize" [(ngModel)]="quote.externalNotes" placeholder="External Notes" #externalNotesInput></textarea>
                    <mat-hint align="end">{{(quote?.externalNotes?.length || 0) + " / 255"}}</mat-hint>
                  </mat-form-field>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="thirdColumn">
        <div class="infoPanel">
          <div class="panelHeader">
            <span>Marketing</span>
          </div>
          <div class="panelBody">
            <table class="layoutTable">
              <tr>
                <td class="rightAligned labelColumn"><span>Market Segment:</span></td>
                <td class="dataColumn">
                  <div [ngClass]="{ inputError: marketSegmentMissing() }">
                    <select name="marketSegmentInput" class="marketingInput" [(ngModel)]="quote.marketSegmentCode" #marketSegmentInput>
                      @for (segment of marketSegments(); track segment) {
                        <option [ngValue]="segment.code">
                          {{ segment.description }}
                        </option>
                      }
                    </select>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Project Type:</span></td>
                <td class="dataColumn">
                  <div [ngClass]="{ inputError: projectTypeMissing() }">
                    <select name="projectTypeInput" class="marketingInput" [(ngModel)]="quote.projectTypeCode" #projectTypeInput>
                      @for (projectType of projectTypes(); track projectType) {
                        <option [ngValue]="projectType.code">
                          {{ projectType.description }}
                        </option>
                      }
                    </select>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Spec Type:</span></td>
                <td class="dataColumn">
                  <div [ngClass]="{ inputError: specTypeMissing() }">
                    <select name="specTypeInput" class="marketingInput" [(ngModel)]="quote.specTypeCode" #specTypeInput>
                      @for (specType of specTypes(); track specType) {
                        <option [ngValue]="specType.code">
                          {{ specType.description }}
                        </option>
                      }
                    </select>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Application Type:</span></td>
                <td class="dataColumn">
                  <div [ngClass]="{ inputError: applicationTypeMissing() }">
                    <select name="applicationTypeInput" class="marketingInput" [(ngModel)]="quote.applicationTypeCode" #applicationTypeInput>
                      @for (appType of applicationTypes(); track appType) {
                        <option [value]="appType.code">
                          {{ appType.description }}
                        </option>
                      }
                    </select>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="infoPanel">
          <div class="panelHeader">
            <span>Quote Totals</span>
          </div>
          <div class="panelBody">
            <table class="layoutTable">
              <tr>
                <td class="rightAligned labelColumn"><span>Total List:</span></td>
                <td class="dataColumn">
                  <span>{{ quote.totalList | currency: "USD" }}</span>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Net Amount:</span></td>
                <td class="dataColumn">
                  <span>{{ quote.netAmount | currency: "USD" }}</span>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Special Quote Amount:</span></td>
                <td class="dataColumn">
                  <span>{{ quote.specialQuoteAmount | currency: "USD" }}</span>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Special Charges:</span></td>
                <td class="dataColumn">
                  <span>{{ quote.specialCharges - quote.shippingHandlingChargeAmount - quote.specialQuoteAmount - quote.partShippingHandlingChargeAmount | currency: "USD" }}</span>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn">Shipping and Handling:</td>
                @if (isShipToStateNeeded()) {
                  <td class="dataColumn" (click)="selectAddress()">
                    <span class="pseudo-link">Please select a Ship To address</span>
                  </td>
                } @else if (isShippingChargeTaskNeeded()) {
                  <td class="dataColumn" (click)="createShippingChargeTask()">
                    <span class="pseudo-link">Shipping Charge Estimate Required</span>
                  </td>
                } @else if (isShippingChargeTaskOpen()) {
                  <td class="dataColumn">
                    <span>Getting rate from freight carrier</span>
                  </td>
                } @else {
                  <td class="dataColumn">
                    {{ quote.shippingHandlingChargeAmount | currency: "USD" }}
                  </td>
                }
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Part Shipping and Handling:</span></td>
                <td class="dataColumn"><span>{{ quote.partShippingHandlingChargeAmount | currency:'USD' }}</span></td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Total Quote Amount:</span></td>
                <td class="dataColumn">
                  <span>{{ quote.totalQuoteAmount | currency: "USD" }}</span>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Multiplier:</span></td>
                <td class="dataColumn">
                  <span>{{ quote.multiplier | number: "1.4-7" }}</span>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Unit Quantity:</span></td>
                <td class="dataColumn">
                  <span>{{ quote.unitQuantity }}</span>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="infoPanel">
          <div class="panelHeader">
            <span>Quote Status</span>
          </div>
          <div class="panelBody">
            <table class="layoutTable">
              <tr>
                <td class="rightAligned labelColumn"><span>Quote Status:</span></td>
                <td class="dataColumn">
                  <span>{{ quote.statusDescription }}</span>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Special Status:</span></td>
                <td class="dataColumn">
                  <span>{{ quote.sfrStatus }}</span>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>FPA Status:</span></td>
                <td class="dataColumn">
                  <span>{{ quote.fpaStatus }}</span>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><span>Approval Status:</span></td>
                <td class="dataColumn">
                  <span>{{ quote.approvalStatus }}</span>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn">
                  <label for="frozenInput">Frozen:</label>
                </td>
                <td class="dataColumn">
                  @if (userHasRole("CustomerService") || userHasRole("IT") || userHasRole("ApplicationEngineer")) {
                    <input name="frozenInput" id="frozenInput" class="checkboxInput" type="checkbox" [(ngModel)]="quote.frozen" />
                  }
                  @if (!userHasRole("CustomerService") && !userHasRole("IT") && !userHasRole("ApplicationEngineer")) {
                    <span>{{ quote.frozen ? "Yes" : "No" }}</span>
                  }
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn">
                  <label for="priceProtectedInput">Price protected:</label>
                </td>
                <td class="dataColumn">
                  @if (userHasRole("IT")) {
                    <input name="priceProtectedInput" id="priceProtectedInput" class="checkboxInput" type="checkbox" [(ngModel)]="quote.priceProtected" />
                  }
                  @if (!userHasRole("IT")) {
                    <span>{{ quote.priceProtected ? "Yes" : "No" }}</span>
                  }
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      @if (quote && !isNew()) {
        <div class="lineToolbar">
          <span class="linesLabel">
            <h3>Quote Lines</h3>
          </span>
          <span class="spacer"></span>
          <span>
            @if (quote.projectProductType === ProjectProductType.COM && !isStockProgram()) {
              <button matButton="text" class="toolbarButton" [disabled]="quote.frozen" (click)="openRiserChartDialog()">
                <span>
                  <mat-icon class="size-16">table_chart</mat-icon>
                  <span class="buttonLabel">Riser Chart</span>
                </span>
              </button>
            }
            @if (quote.updateAllowed) {
              <button matButton="text" [ngClass]="{ skyportTaggingError: taggingRoomMissing() }" [disabled]="isBusy() || quote.frozen" (click)="openUnitTaggingScreen()">
                <span>
                  <mat-icon class="size-16">local_offer</mat-icon>
                  <span class="buttonLabel">Tagging</span>
                </span>
              </button>
            }
            @if ((userHasRole("IT") || userHasRole("CustomerService")) && !isStockProgram()) {
              <button matButton="text" class="toolbarButton" [disabled]="isBusy()" (click)="openLeadTimeDialog()">
                <span>
                  <mat-icon class="size-16">today</mat-icon>
                  <span class="buttonLabel">Lead Times</span>
                </span>
              </button>
            }
            @if (warrantyLineSummaryActive()) {
              <button matButton="text" class="toolbarButton" [disabled]="isBusy() || getSelectedQuoteLineCount() !== 1" (click)="showWarrantyLineSummary()">
                <span>
                  <mat-icon class="size-16">description</mat-icon>
                  <span class="buttonLabel">Warranty Details</span>
                </span>
              </button>
            }
            <button matButton="text" class="toolbarButton" [disabled]="isBusy() || getSelectedQuoteLineCount() !== 1" (click)="showLineSummary()">
              <span>
                <mat-icon class="size-16">visibility</mat-icon>
                <span class="buttonLabel">Summary</span>
              </span>
            </button>
            @if (isStockProgram()) {
              <button matButton="text" class="toolbarButton" [disabled]="isBusy() || !isSingleStockUnitSelected()" (click)="showStockLineSpecifications()">
                <span>
                  <mat-icon class="size-16">list_alt</mat-icon>
                  <span class="buttonLabel">Specs</span>
                </span>
              </button>
            }
            @if (quote.updateAllowed) {
              <button matButton="text" class="toolbarButton" [disabled]="isBusy() || getSelectedQuoteLineCount() === 0 || isSureFlowUnitSelected()" (click)="deleteSelectedLines()">
                <span>
                  <mat-icon class="size-16">delete</mat-icon>
                  <span class="buttonLabel">Delete</span>
                </span>
              </button>
            }
            @if (showConfigurator()) {
              <button matButton="text" class="toolbarButton" [disabled]="isBusy()" (click)="openConfigurator()">
                <span>
                  <mat-icon class="size-16">build</mat-icon>
                  <span class="buttonLabel">Configurator</span>
                </span>
              </button>
            }
            @if (canAddLines()) {
              <button matButton="text" class="toolbarButton" [disabled]="isBusy()" (click)="addParts()">
                <span>
                  <mat-icon class="size-16">add</mat-icon>
                  <span class="buttonLabel">Parts & Warranty</span>
                </span>
              </button>
            }
            @if (!isStockProgram()) {
              <button matButton="text" class="toolbarButton" [disabled]="isBusy() || getSelectedQuoteLineCount() === 0 || isSureFlowUnitSelected() || isDiscontinued()" (click)="copyLines()">
                <span>
                  <mat-icon class="size-16">filter_none</mat-icon>
                  <span class="buttonLabel">Copy To</span>
                </span>
              </button>
            }
            @if (canAddRisers()) {
              <button matButton="text" class="toolbarButton" [disabled]="isBusy()" (click)="addRisers()">
                <span>
                  <mat-icon class="size-16">equalizer</mat-icon>
                  <span class="buttonLabel">Risers</span>
                </span>
              </button>
            }
          </span>
        </div>
      }
      @if (quote && !isNew()) {
        <div>
          <table class="reportTable fullTableWidth">
            <thead>
              <tr>
                <td class="tableCell headerCell centeredCell">Line</td>
                <td class="tableCell headerCell centeredCell">Product</td>
                <td class="tableCell headerCell centeredCell">Description</td>
                <td class="tableCell headerCell centeredCell">Quantity</td>
                <td class="tableCell headerCell centeredCell">Best Lead Time</td>
                <td class="tableCell headerCell centeredCell">Unit List</td>
                <td class="tableCell headerCell centeredCell">Multiplier</td>
                <td class="tableCell headerCell centeredCell">Final Unit Price</td>
                <td class="tableCell headerCell centeredCell">Final Ext Price</td>
                <td class="tableCell headerCell centeredCell">Customer Item #</td>
                <td class="tableCell headerCell centeredCell">Tags</td>
              </tr>
            </thead>
            @if (quote.lines && quote.lines.length > 0) {
              @for (line of quote.lines; track line) {
                <tr
                  [class.selectedRow]="isLineSelected(line)"
                  [class.incompleteRow]="isIncompleteLine(line)"
                  class="selectableRow"
                  (click)="selectQuoteLineRow($event, line)">
                  <td class="tableCell">{{ line.lineId }}</td>
                  <td class="tableCell">{{ productColumn(line) }}</td>
                  <td class="tableCell">{{ line.description }}</td>
                  <td class="tableCell centeredCell">{{ line.quantity }}</td>
                  <td class="tableCell centeredCell">{{ line.bestLeadTime }}</td>
                  <td class="tableCell rightAligned">{{ line.unitList | currency: "USD" }}</td>
                  <td class="tableCell centeredCell">{{ line.multiplier | number: "1.4-7" }}</td>
                  <td class="tableCell rightAligned">{{ line.finalUnitPrice | currency: "USD" }}</td>
                  <td class="tableCell rightAligned">{{ line.finalExtendedPrice | currency: "USD" }}</td>
                  <td class="tableCell">{{ line.customerItemNumber }}</td>
                  <td class="tableCell">
                    @if (line.tags && line.tags.length > 0) {
                      <span>{{ line.tags.substring(0, 20) + (line.tags.length > 20 ? "..." : "") }}</span>
                    }
                  </td>
                </tr>
              }
            }
            @if (!quote.lines || quote.lines.length === 0) {
              <tr>
                <td colspan="11">No lines found</td>
              </tr>
            }
          </table>
        </div>
      }
    </div>
  }
</form>
